import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.png';

export function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <img src={logo} alt="Barbor Meals" className="h-12 w-auto mb-4 invert" />
            <p className="text-primary-foreground/70 leading-relaxed">
              אנחנו מכינים מנות בריאות וטעימות עבור אנשים שמחפשים לשמור על אורח חיים בריא מבלי להתפשר על הטעם.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">צרו קשר</h3>
            <div className="space-y-3">
              <a
                href="tel:+972546862515"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Phone className="h-5 w-5" />
                054-686-2515
              </a>
              <a
                href="mailto:info@barbormeals.com"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Mail className="h-5 w-5" />
                info@barbormeals.com
              </a>
              <div className="flex items-center gap-3 text-primary-foreground/70">
                <MapPin className="h-5 w-5" />
                נצרת רח 9010
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-10 pt-6 text-center text-primary-foreground/50">
          <p className="mb-2">© 2026 Barbor Meals. כל הזכויות שמורות.</p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link to="/terms" className="hover:text-primary-foreground transition-colors underline">
              תקנון האתר
            </Link>
            <Link to="/privacy" className="hover:text-primary-foreground transition-colors underline">
              מדיניות פרטיות
            </Link>
            <Link to="/shipping" className="hover:text-primary-foreground transition-colors underline">
              מדיניות משלוחים
            </Link>
            <Link to="/returns" className="hover:text-primary-foreground transition-colors underline">
              מדיניות החזרות
            </Link>
            <Link to="/accessibility" className="hover:text-primary-foreground transition-colors underline">
              הצהרת נגישות
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
